import coreApi from '@appmaker/core/api/core';
import { useReducer, useEffect } from 'react';
import useProjectGraphQl from '../store/project-graphql';

const initialState = {
	loading: true,
	projectId: null,
	error: '',
	projectData: {},
};

const reducer = (state, action) => {
	switch (action.type) {
		case 'FETCH_START':
			return { ...initialState, projectId: action.projectId };
		case 'FETCH_SUCCESS':
			return {
				loading: false,
				projectId: action.projectId,
				projectData: action.payload,
				error: '',
			};
		case 'FETCH_ERROR':
			return {
				loading: false,
				projectId: action.projectId,
				projectData: {},
				error: action.error,
			};
		default:
			return state;
	}
};

function useProjectData(config) {
	const { projectId } = config;
	const [state, dispatch] = useReducer(reducer, initialState);
	const { setProject } = useProjectGraphQl();
	useEffect(() => {
		let active = true;
		async function start() {
			dispatch({ type: 'FETCH_START', projectId });
			setProject({});
			try {
				const data = await coreApi.getProject(projectId);
				if (!active) return;
				// Do not fetch additional project data after a legacy access denial.
				if (data && Object.keys(data).length > 0 && data.status !== false) {
					try {
						const graphqlData = await coreApi.getProjectGraphQl(projectId);
						if (active) setProject(graphqlData || {});
					} catch (error) {
						// Supplementary GraphQL data must not block the main dashboard.
					}
				}
				if (active) dispatch({ type: 'FETCH_SUCCESS', payload: data, projectId });
			} catch (error) {
				if (active) dispatch({ type: 'FETCH_ERROR', error, projectId });
			}
		}
		start();
		return () => { active = false; };
	}, [projectId, setProject]);
	// A route change must never briefly display the previous project's data.
	return state.projectId === projectId ? state : initialState;
}

export default useProjectData;
